import { LoadingSpinner } from "~/components/LoadingSpinner";

// // // //

/**
 * Renders a loading state state for AssetTokenHolders
 */
export function TokenHoldersLoadingState() {
    return (
        <div className="relative w-full h-full flex flex-col justify-center items-center px-12 py-36 text-center text-slate-400">
            <LoadingSpinner size={10} />
        </div>
    );
}
